export const VAULTS_TABLE_DEFAULT_LIMIT = 10;

// The largest page `listVaults` will serve.
export const VAULTS_MAX_LIMIT = 100;

export const VAULTS_FILTER_ALL_VALUE = 'all';

// Named after the request body's own keys, so submitting is a rename-free mapping.
export enum VaultFormField {
    NAME = 'name',
    GROUPS = 'groups',
    USERS = 'users',
}
